import styled from 'styled-components';
import Typography from '@material-ui/core/Typography';
import { motion } from 'framer-motion';


export const ListContent = styled.div`
  /* background: ${props => props.animate};
    transition: all 3s; */
    min-height: 80px;
    padding: 8px 16px 20px;
    width: 100%;
  &:hover {
    background: ${props => props.hover};
  }
`;


export const MessageContent = styled.span`
  font-size: 14px;
`;

export const MessageDate = styled(Typography)`
  padding: 12px;
  font-size: 12px;
  color: #333333;

`;

export const MessageTitle = styled.div`
  display: flex;
  font-weight: bold;
  justify-content: space-between;
  align-items: center;
  min-width: 300px;

`;

export const ShowMore = styled.div`
  display: flex;
  justify-content: center;
  margin: 5px
`;

export const RedNot = styled.div`
   width: 6px; 
   height: 6px; 
   border-radius: 50%;
  background: red; 
  margin: 5px;
`;

export const AnimationContainer = styled(motion.div)`
 display: flex;
 overflow: hidden;
 height: 100%;
 background: white;
 position: relative;
  &:hover {
   background: ${props => (props.isRead ? '#F5F5F5' : '')};  
  }
`;
